import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast' // Using UI toast from design system
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface GenerateEventDescriptionInput {
  eventId: string
  // Optional additional parameters to influence generation
  keywords?: string[]
  grade_levels?: string[]
  engagement_opportunities?: string[]
}

interface GenerateEventDescriptionResponse {
  success: boolean
  title: string
  description: string
}

/**
 * Hook that provides a mutation for generating event descriptions and titles using AI
 * @returns Mutation object for generating event descriptions and titles
 */
export const useGenerateEventDescriptionMutation = () => {
  const fetchWithAuth = useFetchWithAuth()

  return useMutation<
    GenerateEventDescriptionResponse,
    Error,
    GenerateEventDescriptionInput
  >({
    mutationFn: async (data) => {
      const response = await fetchWithAuth(
        `${URL}/events/${data.eventId}/generate`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }
      )
      return response
    },
    onError: (error) => {
      console.error('Generate event description error:', error)
      toast.error('Failed to generate event description. Please try again.')
    },
  })
}
